import { RegionsEnum } from 'src/generated/operations';
import { MESSAGES } from 'src/modules/common/constants';
import { FormFields } from 'src/modules/user-input/FormFieldNames.ts';

export const getUserInputFormFieldKey = (region: RegionsEnum, field: FormFields): string => {
    const kvCvLabel = region === RegionsEnum.Am ? MESSAGES.CV : MESSAGES.KV;
    const kvCvLabel2 = region === RegionsEnum.Am ? MESSAGES.CV_2 : MESSAGES.KV_2;
    const map = {
        mass: MESSAGES.massFlow,
        inlet: MESSAGES.inlet,
        outlet: MESSAGES.outlet,
        v100: MESSAGES.v100,
        v100_2: MESSAGES.v100_2,
        maxDp: MESSAGES.maxDp,
        maxDp_2: MESSAGES.maxDp,
        kvs: kvCvLabel,
        kvs_2: kvCvLabel2,
    };
    return map[field];
};
